export default __webpack_public_path__ + "static/media/plus.6cb8dc1b.png";